import React from 'react';

import ReactDOM from 'react-dom/client';

import { bootstrapAutoLogin } from './utils/autoLogin';

bootstrapAutoLogin();

const root = ReactDOM.createRoot(document.getElementById('root')!);

void import('./App').then(({ default: App }) => {
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);

	void import('./reportWebVitals').then(({ default: reportWebVitals }) => {
		reportWebVitals();
	});
});
